import { render, staticRenderFns } from "./tiaolidetail.vue?vue&type=template&id=e6b69c06&scoped=true&"
import script from "./tiaolidetail.vue?vue&type=script&lang=js&"
export * from "./tiaolidetail.vue?vue&type=script&lang=js&"
import style0 from "./tiaolidetail.vue?vue&type=style&index=0&id=e6b69c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b69c06",
  null
  
)

export default component.exports